import { UserManager } from 'oidc-client';
import jwtDecode from 'jwt-decode';

import authConfig from './authConfig';
import { signinSCG, signinExt, Request, Response } from '../../api/auths';
import { UserContextType } from '../UserProfile/userProfileSlice';
import { RouteComponentProps } from 'react-router-dom';

const {
  AUTHORITY,
  CLIENT_ID,
  REDIRECT_URI,
  RESPONSE_TYPE,
  AUTHORIZATION_URI,
  END_SESSION_URI,
  SCOPE
} = authConfig;

const userManager = new UserManager({
  authority: AUTHORITY,
  client_id: CLIENT_ID,
  // resource: CLIENT_ID,
  redirect_uri: REDIRECT_URI,
  response_type: RESPONSE_TYPE,
  scope: SCOPE,
  metadata: {
    authorization_endpoint: AUTHORIZATION_URI,
    end_session_endpoint: END_SESSION_URI
  }
});

export function getCode() {
  return new URLSearchParams(window.location.search).get('code');
}

export function getUser() {
  const token = getToken();
  if (token) {
    const { user }: UserContextType = jwtDecode(token);
    return user;
  }
  return null;
}

export function getToken() {
  return localStorage.getItem('token');
}

export function getExp() {
  const token = getToken();
  if (token) {
    const { exp }: UserContextType = jwtDecode(token);
    return exp;
  }
  return null;
}

export function getCoverPic() {
  return localStorage.getItem('coverPic');
}

export function getProfilePic() {
  return localStorage.getItem('profilePic');
}

export function signinRedirect() {
  // The userManager.signinRedirect method can't be used since it appends query strings
  // that are not supported by SCG ADFS, for example, state, code_challenge, and code_challenge_method.
  // See more https://github.com/IdentityModel/oidc-client-js/blob/dev/src/SigninRequest.js#L54-L65

  /* SCG ADFS code */
  const searchParams = new URLSearchParams({
    response_type: RESPONSE_TYPE,
    client_id: CLIENT_ID,
    resource: CLIENT_ID,
    redirect_uri: REDIRECT_URI
  });
  const redirectUri = `${AUTHORIZATION_URI}?${searchParams.toString()}`;
  window.location.href = redirectUri;
}

export async function signin({
  code,
  history
}: {
  code: string;
  history: RouteComponentProps['history'];
}) {
  try {
    const response = await signinSCG({
      code,
      redirectUri: REDIRECT_URI
    });
    return decodeResponse(response);
  } catch {
    history.push('/login');
    throw new Error('User not found|404');
  }
}

export async function signinExternal(request: Request) {
  const response = await signinExt(request);
  return decodeResponse(response);
}

function decodeResponse(response: Response): UserContextType {
  const { token } = response.data;
  const { user, exp }: UserContextType = jwtDecode(token);

  localStorage.setItem('token', token);
  return { user, token, exp };
}

export function signout() {
  localStorage.removeItem('token');
  localStorage.removeItem('coverPic');

  /* SCG ADFS code */
  userManager.signoutRedirect();
}

export function saveRedirectUrl(redirectUrl: string): void {
  localStorage.setItem('redirectUrl', redirectUrl);
}

export function redirectAfterLogin(
  history: RouteComponentProps['history']
): void {
  const redirectUrl = localStorage.getItem('redirectUrl');

  if (redirectUrl) {
    history.push(redirectUrl);
    localStorage.removeItem('redirectUrl');
  } else {
    history.push('/');
  }
}
